// extracted by mini-css-extract-plugin
export var productImage = "_p6-1";
export var viewLink = "_p6-2";
export var wishlistItem = "_p6-0";